import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { useLicenseChecker } from 'components/GlobalState/useLicenseChecker';
import { useLocale } from 'containers/App/LocaleContext';
import { useCurrentSnapshot } from 'pages/SnapshotManagement/useCurrentSnapshot';
import { useEffect } from 'react';
import type { FC } from 'react';

import { prop } from '@ipfabric/utils/fp/prop';
import LTEBox from 'containers/LTEBox';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export const LicenseLimitExceededPage: FC = () => {
  const snapshot = useCurrentSnapshot();
  const navigate = useNavigate();
  const licenseChecker = useLicenseChecker();
  const globalStateCtxProps = useGlobalStateContextSelectors({
    licenseLimit: prop('license', 'devices'),
  });
  const exceededMsg = useLocale().licenseLimitExceeded;

  useEffect(() => {
    if (
      snapshot === null ||
      licenseChecker.lteDeviceLimit({ devices: snapshot.licensedDevCount })
    ) {
      // leave this page if irrelevant (current snapshot does not exceed max licensed devices)
      navigate('/');
    }
  }, [snapshot, licenseChecker]);

  return (
    <>
      <Helmet title={exceededMsg.title} />
      <LTEBox
        bodyComponent={
          <div>
            <p>{exceededMsg.explanation}</p>
            {globalStateCtxProps.licenseLimit !== null && (
              <p>
                {exceededMsg.licenseDeviceLimit.replace(
                  '{licenseLimit}',
                  globalStateCtxProps.licenseLimit.toString(10),
                )}
              </p>
            )}
            {snapshot !== null && (
              <p>
                {exceededMsg.licensedDevicesCount.replace(
                  '{licensedDevices}',
                  snapshot.licensedDevCount.toString(10),
                )}
              </p>
            )}
          </div>
        }
        className='box box-primary m-4 w-auto'
        title={exceededMsg.boxTitle}
      />
    </>
  );
};
